import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DomainContextService {
  readonly hostname = window.location.hostname;


  private readonly domainGroupMap: Record<string, string> = {
    'localhost': 'ddb131c8-4978-47ab-98ea-4e5c7add9390',
    'uat-consent.chill.ie': '17f39465-0c37-4754-9976-0ac0129c5ec2',
    'uat-consent.quotedevil.ie': 'fcab5acd-ef51-4b6f-99f3-227a9e1d961e',
    'consent.chill.ie': '9510622f-bc23-4f58-b637-cf538fa064bb',
    'consent.quotedevil.ie': 'ddb131c8-4978-47ab-98ea-4e5c7add9390'
  };

 get expectedGroupId(): string | null {
    return this.domainGroupMap[this.hostname] ?? null;
  }
}
